module.exports = __webpack_public_path__ + "static/media/condensed2BetaBadges.94942686.svg";